module.exports = __webpack_public_path__ + "static/media/ql-icon-discount.0e78102d.svg";